
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investisseurs",
      function () {
        return require("private-next-pages/investisseurs/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investisseurs"])
      });
    }
  